import Box from '@amzn/awsui-components-react-v3/polaris/box';
import React from 'react';
import { formatName } from '../../../utils/components';
import { ErrorFlash } from '../../content/error_flash';
import { getJSClient } from '../../js_client';
import { OPERATION_STATUS } from '../common/constants';
import { FLCPSAccuracySummaryTable } from './flcp_accuracy_summary_table';
import { FLCPHeader } from './flcp_header';
import { FLCPComponentsOrdering, formatNumber } from './flcp_utils';

export class FLCPAccuracyReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accuracySummaryLoadStatus: OPERATION_STATUS.NONE,
    };
    this.reportData = [];
  };

  componentDidMount = () => {
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.client = getJSClient();
    this.pullFLCPAccuracySummary(this.props.payload);
  };

  pullFLCPAccuracySummary = (payload) => {
    this.setState({accuracySummaryLoadStatus: OPERATION_STATUS.IN_PROGRESS});
    this.client.getFLCPAccuracySummary(this.processAccuracySummaryResults, this.onFailedAccuracySummaryRequest, payload)
        .then(() => this.setState({accuracySummaryLoadStatus: OPERATION_STATUS.SUCESS}));
  };

  processAccuracySummaryResults = (response) => {
    const componentMap = new Map();
    const reportRows = [];
    let absVariancePerUnitSum = 0;
    if(response  && response.componentValues){
      for(const row of response.componentValues){
        const component = formatName(row.component);
        const absVariancePerUnit = formatNumber(row.absVariancePerUnit);
        absVariancePerUnitSum += row.absVariancePerUnit;
        componentMap.set(component, absVariancePerUnit);
      }

      FLCPComponentsOrdering.forEach(component => {
        const absVariancePerUnit = componentMap.get(component);
        reportRows.push({component, absVariancePerUnit});
      })
    }
    reportRows.push({component: 'Total', absVariancePerUnit: absVariancePerUnitSum});
    this.reportData = reportRows;
  };

  onFailedAccuracySummaryRequest = () => {
    this.setState({accuracySummaryLoadStatus: OPERATION_STATUS.FAIL});
  };

  render() {
    return (
      <Box margin="l">
        <FLCPHeader updateTools={this.props.updateTools} payload={this.props.payload}/>
        {this.state.accuracySummaryLoadStatus === OPERATION_STATUS.FAIL && (<ErrorFlash type="FLCP Accuracy Summary" />)}
        <FLCPSAccuracySummaryTable items={this.reportData}
                                   payload={this.props.payload}
                                   loading={this.state.accuracySummaryLoadStatus === OPERATION_STATUS.IN_PROGRESS}
        />
      </Box>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/reports/flcp/flcp_accuracy_report.js